import { Typography } from '@blofin/blofin-ui';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import activityImg from '../../../public/images/activity.png';
import activityH5 from '../../../public/images/activity-h5.png';
import styles from './Hero.module.scss';

export default function SubHero({ isMobile }: { isMobile: boolean }) {
  const t = useTranslations('activity');

  return (
    <div className={styles.subHero}>
      <div className="flex w-full items-center justify-between px-[20px] md:max-w-[1200px] md:px-0">
        <div className="flex w-full items-center justify-center">
          <div className="flex basis-1/2 flex-col gap-4">
            <Typography variant="h3" weight="bold" className="text-2xl leading-[32px] xl:text-7xl xl:leading-[60px]">
              {t('activityCenter')}
            </Typography>
            <Typography
              variant="subtitle3"
              weight="regular"
              className="!text-base leading-[20px] text-light-label-60 xl:!text-xl xl:leading-[30px]"
            >
              {t('activityCenterSubTitle')}
            </Typography>
          </div>
          <div className="flex basis-1/2 items-center justify-end">
            <Image
              src={isMobile ? activityH5 : activityImg}
              width={0}
              height={0}
              className="w-full xl:!h-[344px] xl:!w-[600px]"
              alt="hero"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
